import { store } from "src/index";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import { ROLE } from "src/redux/TopBar/constants";
import { TopBarSelectors } from "src/redux/TopBar/selectors";

export default (params) => {
    const state = store.getState();
    const { preferredCcy } = SettingsSelectors.UserSettings(state);
    const role = TopBarSelectors.Role(state);

    let headerName = params.colDef.headerName;

    if (headerName.includes("<role>")) {
        headerName = headerName.replace(
            "<role>",
            role === ROLE.LENDER ? "Response" : "Sent"
        );
    }

    if (!preferredCcy) return headerName;

    if (headerName.endsWith(")")) {
        return headerName.replace("(", `(${preferredCcy}, `);
    }
    return `${headerName} (${preferredCcy})`;
};
